/**
 * Product page and product tile quantity selector component
 */
const addToCart = {};

/**
 * Imports
 */
var processInclude = require('base/util');

/**
 * Component configuration constants
 */
const CONFIG = {
    SELECTORS: {
        ACTION: '.add-to-cart-url',
        COMPONENT: '.hom-js-add-to-cart',
        QUANTITY_SELECTOR: '.hom-js-quantity-selector'
    },
    CLASS: {
        HIDDEN: 'hom-display--none'
    },
    ATTRIBUTES: {
        DISABLED: 'disabled'
    }
};

/**
 * Private functions
 */

/**
 * Verify if all arguments have a valid value.
 * @param {any} arguments - 1 or more arguments to validate
 * @returns {boolean} true if all arguments are valid
 */
function isValid() {
    var argument;

    for (var i = 0; i < arguments.length; i++) {
        argument = arguments[i];

        if (argument === undefined && argument === null && argument === 'undefined' && argument === 'null') {
            return false;
        }
    }

    return true;
}

/**
 * Collection of functions which set the status of an element.
 */
const setStatus = {
    /**
     * Add the hidden class to the given element.
     * @param {JQuery<HTMLElement>} $element - element to add the hidden class
     */
    hidden: function ($element) {
        if (!isValid($element)) {
            return;
        }

        $element.addClass(CONFIG.CLASS.HIDDEN);
    },

    /**
     * Remove the hidden class to the given element.
     * @param {JQuery<HTMLElement>} $element - element to remove the hidden class
     */
    shown: function ($element) {
        if (!isValid($element)) {
            return;
        }

        $element.removeClass(CONFIG.CLASS.HIDDEN);
    },

    /**
     * Add the disabled attribute to the given element.
     * @param {JQuery<HTMLElement>} $element - element to add the disabled attribute
     */
    disabled: function ($element) {
        if (!isValid($element)) {
            return;
        }

        $element.attr(CONFIG.ATTRIBUTES.DISABLED, '');
    },

    /**
     * Remove the disabled attribute to the given element.
     * @param {JQuery<HTMLElement>} $element - element to remove the disabled attribute
     */
    enabled: function ($element) {
        if (!isValid($element)) {
            return;
        }

        $element.removeAttr(CONFIG.ATTRIBUTES.DISABLED);
    }
};

/**
 * Collection of functions which represent server interactions.
 */
const server = {
    minicartReport: function (action) {
        if (!isValid(action)) {
            return;
        }

        $.ajax({
            action: action,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    },

    addToCart: function (action, pid, quantity, pidsObj, childProducts, $button, $quantitySelector) {
        if (!isValid(action, pid, quantity, pidsObj, childProducts, $button, $quantitySelector)) {
            return;
        }

        // 1. Start loading spinner
        $.spinner().start();

        // 2. Disable button to avoid multiple clicks
        setStatus.disabled($button);

        // 3. Execute AJAX cll
        $.ajax({
            url: action,
            method: 'POST',
            data: {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: childProducts,
                quantity: quantity
            },
            success: function (response) {
                // 1. Execute custom events
                if (response.cart) {
                    $('body').trigger('count:update', response.cart);
                }
                $('body').trigger('product:afterAddToCart', response);

                // 2. Report minicart
                server.minicartReport(response.reportingURL);

                // 3. Show alert message
                $.alert().success(response.message);

                // 4. Hide button & show quantity selector
                $('body').trigger('hom:addToCart:hide', { $element: $button });
                $('body').trigger('hom:quantitySelector:show', { $element: $quantitySelector });
                $('body').trigger('hom:quantitySelector:setPlusStatus', { $element: $quantitySelector });
            },
            error: function (response) {
                $.alert().error(response.responseJSON.message);
            },
            complete: function () {
                $.spinner().stop();

                // Enable the button
                setStatus.enabled($button);
            }
        });
    }
};

/**
 * Collection of getter functions related with all add to cart button values.
 */
const getValue = {
    /**
     * Get add product to cart action url.
     * @returns {string | undefined} product add to cart action url
     */
    action: function () {
        const value = $(CONFIG.SELECTORS.ACTION).val();

        if (!isValid(value)) {
            return undefined;
        }

        return value;
    },

    /**
     * Get quantity attribute stored in button quantity data attribute.
     * @param {JQuery<HTMLElement>} $button - add to cart button
     * @returns {number | undefined} quantity data attribute
     */
    quantity: function ($button) {
        const value = $button.data('quantity');

        if (!isValid(value)) {
            return undefined;
        }

        return value;
    },

    /**
     * Get product id.
     * @param {JQuery<HTMLtElement>} $button - input jquery element which contains the product id
     * @returns {number | undefined} product id
     */
    pid: function ($button) {
        const value = $button.data('pid');

        if (!isValid(value)) {
            return undefined;
        }

        return value;
    }
};

/**
 * Collection of functions which attach event listeners to all interactive HTMLElement type objects.
 */
const onClick = {
    button: function () {
        $('body').on('click', CONFIG.SELECTORS.COMPONENT, function () {
            // Constants
            const $this = $(this);
            const $quantitySelector = $this.siblings(CONFIG.SELECTORS.QUANTITY_SELECTOR);
            const action = getValue.action();
            const childProducts = [];
            const quantity = getValue.quantity($this);
            const pid = getValue.pid($this);
            const pidsObj = [];

            // 1. Execute required actions before adding to cart
            $('body').trigger('product:beforeAddToCart', this);

            // 2. Execute AJAX call
            server.addToCart(action, pid, quantity, pidsObj, childProducts, $this, $quantitySelector);
        });
    }
};

/**
 * Collection of functions which attach custom event listeners.
 */
const onCustom = {
    hide: function () {
        $('body').on('hom:addToCart:hide', function (e, data) {
            if (isValid(data) && '$element' in data && data.$element.length) {
                setStatus.hidden(data.$element);
            }
        });
    },

    show: function () {
        $('body').on('hom:addToCart:show', function (e, data) {
            if (isValid(data) && '$element' in data && data.$element.length) {
                setStatus.shown(data.$element);
            }
        });
    }
};

/**
 * Exposed functions
 */
addToCart.setEvents = function () {
    processInclude(onClick);
    processInclude(onCustom);
};

module.exports = addToCart;
